<template>
    <div class="goods_box">
        <div class="left">
            <div class="box">
                <img class="goods_icon" :src="info.icon_url" alt="">
            </div>
        </div>
        <div class="right" v-if="type == 1">
            <div class="center">
                <!-- <p class="price">
                    <span>参考价格：</span>
                    <span class="yen"><i class="symbol">&yen;</i>{{ info.price }}</span>
                </p> -->
                <p class="num">
                    <span>在售数量：</span>
                    <span class="suffix">{{ total }}</span>
                </p>
            </div>
        </div>
        <div class="right" v-else-if="type == 2">
            <div class="main_cont">
                <div class="name_num">
                    <!-- <div class="name" v-if="title.length > 6">
                        <p>{{ title.slice(0,6) }}</p>
                        <p class="line2">{{ title.slice(6,title.length) }}</p>
                    </div> -->
                    <div class="name">
                        <p>{{ title }}</p>
                    </div>
                    <div class="num">剩余数量：1</div>
                </div>
                <div class="price">
                    售价：<span class="yen">&yen;{{info.price}}&nbsp;/</span><span class="percent">1</span>
                </div>
            </div>
        </div>
        <div class="right" v-else-if="type == 3||type == 4">
            <div class="main_cont">
                <div class="name_num">
                    <!-- <div class="name" v-if="title.length > 6">
                        <p>{{ title.slice(0,6) }}</p>
                        <p class="line2">{{ title.slice(6,title.length) }}</p>
                    </div> -->
                    <div class="name">
                        <p>{{ title }}</p>
                    </div>
                    <div :class="{'num':true,'success':type == 3,'red':type == 4}">购买：1</div>
                </div>
                <div class="price">
                    售价：<span :class="{'yen2':true,'success':type == 3,'red':type == 4}" style="font-weight: 700;">&yen;{{ order.price }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'goods-box',
    props: {
        type: {
            type: [String,Number],
            default: 1
        },
        info: {
            type: Object,
            default: {}
        },
        order: {
            type: Object,
            default: {}
        },
        title: {
            type: String,
            default: ''
        },
        total: {
            type: [String,Number],
            default: 0
        }
    },
    data() {
        return {
            
        }
    },
}
</script>
<style lang="less" scoped>
    .goods_box {
        display: flex;
        align-items: flex-start;
        height: 8.6rem;
        background-color: #fff;
        border-radius: 0.3rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
        overflow: hidden;
        .left {
            width: 17rem;
            height: 100%;
            background: url(../assets/bx/goods_bg.png) no-repeat 0 0 / 100% 100%;
            position: relative;
            .box {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                width: 3rem;
                height: 3rem;
                background: url(../assets/bx/goods_kuang.png) no-repeat 0 0 / 100% 100%;
                .goods_icon {
                    height: 100%;
                }
            }
        }
        .right {
            flex: 1;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .center {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
            p {
                margin-bottom: 1rem;
                &:nth-last-child(1) {
                    margin-bottom: 0;
                }
                &.price {
                    font-size: 1.6rem;
                    padding: 0 0.5rem;
                    word-break: break-all;
                    .yen {
                        color: var(--red);
                        font-weight: 700;
                        .symbol {
                            display: inline-block;
                            transform: scale(0.75);
                            transform-origin: 0 100%;
                        }
                    }
                }
                &.num {
                    color: #aaa;
                    .suffix {
                        color: var(--enough);
                    }
                }
            }
            .main_cont {
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                padding: .6rem 1rem 1rem;
                .name_num {
                    position: relative;
                    .name {
                        word-break: break-all;
                        font-size: 1.45rem;
                        width: calc(100% - 5rem);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        p {
                            line-height: 1.6rem;
                        }
                        .line2 {
                            width: 15rem;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                    }
                    .num {
                        position: absolute;
                        right: 0;
                        top: 0;
                        color: #aaa;
                        font-size: 1.2rem;
                        transform: scale(0.95);
                        transform-origin: 100% 100%;
                        margin-left: 0.8rem;
                        white-space: nowrap;
                        
                    }
                }
                .price {
                    color: #aaa;
                    .yen {
                        color: var(--red);
                        font-weight: 700;
                        margin-right: 0.8rem;
                    }
                    .percent {
                        color: #000;
                    }
                }
            }
            .success {
                color: var(--success);
            }
            .red {
                color: var(--red);
            }
        }
    }
</style>